export default "__VITE_PUBLIC_ASSET__011a3504__"